<template>
        <div class="col-md-10">
            <div class="featured-box homePage">
                    <div class="mobile-nav-bg mobile-tabs">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation" v-for="(sport, sIndex) in primary_non_custom_sports" :key="sIndex">
                                <button class="nav-link" :class="{active: activeTab == sport.slug }" :id="'all-tab' + sport.id" data-bs-toggle="tab" data-bs-target="#Football" type="button" role="tab"
                                    @click="activeTab != sport.slug ? getSportsListService(sport) : ''">
                                <div class="nav-img">
                                    <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                </div>
                                <span>{{ $t(sport.slug?.toLowerCase()?.replaceAll(' ','-'),sport.name) }}</span>
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" v-for="(sport, sIndex) in custom_sports" :key="sIndex">
                                <button class="nav-link" :class="{active: activeTab == sport.slug }" :id="'all-tab' + sport.id" data-bs-toggle="tab" data-bs-target="#Football" type="button" role="tab"
                                    @click="activeTab != sport.slug ? getSportsListService(sport) : ''">
                                <div class="nav-img">
                                    <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                </div>
                                <span>{{ $t(sport.slug?.toLowerCase()?.replaceAll(' ','-'),sport.name) }}</span>
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" v-for="(sport, sIndex) in secondary_non_custom_sports" :key="sIndex">
                                <button class="nav-link" :class="{active: activeTab == sport.slug }" :id="'all-tab' + sport.id" data-bs-toggle="tab" data-bs-target="#Football" type="button" role="tab"
                                    @click="activeTab != sport.slug ? getSportsListService(sport) : ''">
                                <div class="nav-img">
                                    <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                </div>
                                <span>{{ $t(sport.slug?.toLowerCase()?.replaceAll(' ','-'),sport.name) }}</span>
                                </button>
                            </li>
        
                        </ul>
                    </div>
        
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade active show" id="Football" role="tabpanel" aria-labelledby="Football-tab">
                            <ul class="live_virtual">
                                    <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="toggleFilter('live')"><label>{{$t('live','LIVE')}}</label></li>
                                    <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="toggleFilter('virtual')"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                            </ul>
                            <div class="mobile-game-live sports-height">
                                
                                <div class="game-listing-container" v-if="filteredMatchList?.length">
                                    
                                    <MobileSportItem :sportItemDetail="filteredMatchList"></MobileSportItem>
                            
                                </div>
                                <div class="norecords" v-if="filteredMatchList?.length==0 && loading==false">
                                    {{$t('no-real-records', 'No Record Found')}}
                                </div>
                            </div>
        
                            <section class="bet-details-sec">
                                <div class="game-live">
                                    <div class="tabs-menu-head">
                                        <div class="row">
                                            <div class="col-md-8"><span class="game-mode">{{$t('match', 'Match')}}</span></div>
                                            <div class="col-md-4">
                                                <div class="oddsEventlist">
                                                    <div class="btn-group"><span>1</span></div>
                                                    <div class="btn-group"><span>X</span></div>
                                                    <div class="btn-group"><span>2</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <SportItem :sportItemDetail="matches_list"></SportItem>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div id="casinosection"></div>
                    <section class="produact-item" v-if="showCasino">
                        <div class="prouduts" v-if="sectionWiseGamesList[0]?.gamesList?.menus">
                            <template v-for="(game, gIndex) in sectionWiseGamesList[0]?.gamesList?.menus" :key="gIndex">
                                <GameItem :games="game.games"></GameItem>
                            </template>
                        </div>
                    </section>
            </div>
        </div>

        <!-- Back to top button -->
    <div class="scroll-move-to-top-btn">
        <div class="contentDiv" id="content">
            <button class="back-to-top" :class="{show: scrollHeight , showUp: onFooter}" type="button" @click="scrollToTop()"></button>
        </div>
    </div>
</template>
<script>

import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { checkForLockedMatches, checkEventManageforSports, checkInEventMangeForSection } from '@/shared/services/eventLocks.js';

export default {
name: "Sports",
components: {
    SportItem: defineAsyncComponent(() =>
        import('../components/SportItem.vue')
    ),
    MobileSportItem: defineAsyncComponent(() =>
        import('../components/MobileSportItem.vue')
    ),
    GameItem: defineAsyncComponent(() =>
        import('@/shared/components/games/GameItem.vue')
    ),
    CricketFight: defineAsyncComponent(() =>
        import('@/modules/cricket-fight/views/cricketMatchList.vue')
    ),
    Banner: defineAsyncComponent(() =>
        import('@/shared/components/banner/Banner.vue')
    ),
},
data() {
    return {
        matches_list: [],
        leagueList: [],
        scrollHeight: window.scrollY,
        onFooter: window.scrollY,
        sportsList: [],
        marketOdds: {},
        activeTab: 'cricket',
        sectionWiseGamesList: [
            {
                slugName: 'our-casino',
                gamesList: null
            },
        ],
        selectedFilters: [],
        loading: false,
        CasinoObserver:null,
        showCasino:false,
    };
},

computed: {
    ...mapGetters(['sports_list','siteSettings', 'gamesData','eventManage']),	
    primary_non_custom_sports() {
        return this.sportsList?.non_custom?.filter(sport => [1, 2, 3, 4].includes(sport.rank))
    },
    secondary_non_custom_sports() {
        return this.sportsList?.non_custom?.filter(sport => ![1, 2, 3, 4].includes(sport.rank))
    },
    custom_sports() {
        return this.sportsList?.custom
    }, 
    filteredMatchList() {
        if (this.selectedFilters.includes('live') && this.selectedFilters.includes('virtual')) {
            return this.matches_list || [];
        }
        if (this.selectedFilters.includes('live')) {
            const temporaryData = (this.matches_list || []).filter(match => match.is_exclusive === 0);
            return temporaryData;
        }

        if (this.selectedFilters.includes('virtual')) {
            return (this.matches_list || []).filter(match => match.is_exclusive === 1);
        }

        return this.matches_list || [];
    },       
},
async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    try {
        await Promise.all([
            this.store_sportsList(),
            this.getCasinoGamesServiceCall(),
            this.getInplayMatches()
        ]);
        this.$store.dispatch('setDataLoading',true);
    } catch (err) {
        console.error('Error while loading data:', err);
    }
},
methods: {
    scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        handleScroll() {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;
        
            const scrolledPercent = (scrollTop + windowHeight) / docHeight;
        
            // Show when scroll > 200px
            this.scrollHeight = scrollTop > 200;
        
            // Show special effect near footer (past 90% scroll)
            this.onFooter = scrolledPercent > 0.9;
        },
    getInplayMatches() {
        this.$store.dispatch('setGlobalLoader', true);
        this.$apiCall('get', 'INPLAY_MATCHES_LIST', null, 'sports').then(response => {
            this.$store.dispatch('setGlobalLoader', false);
            if (response && response.status == 200) {
                let recommendedGames = response.data.data.recommended;
                let lockedMatchIds = [];
                let lockedLeagueIds = [];

                if (this.$auth?.status && this.eventManage) {
                    lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                    lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                    lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                    lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : [];
                }
                for (var i = recommendedGames.length - 1; i >= 0; i--) {
                    if (!checkEventManageforSports(recommendedGames[i]?.sport_id) ||
                        !checkForLockedMatches(recommendedGames[i].matchId, recommendedGames[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                        recommendedGames.splice(i, 1);
                    }
                }
                this.$store.dispatch('setRecommendedMatch',recommendedGames);

            }
        }).catch(error => {
            this.$store.dispatch('setGlobalLoader', false);
            this.loading = false;
            if (error) {
                console.log("Error : ", error);
            }
        });
    },
    toggleFilter(filterKey) {
        if (this.selectedFilters.includes(filterKey)) {
            this.selectedFilters = this.selectedFilters.filter(f => f !== filterKey);
        } else {
            this.selectedFilters.push(filterKey);
        }            
    },
    store_sportsList() {
        this.loading = true;
        this.$store.dispatch('setGlobalLoader', true);
        this.$apiCall('get', 'GET_SPORTS', null, 'sports').then(response => {
            this.loading = false;
            this.$store.dispatch('setGlobalLoader', false);
            if (response) {
                if (response.status == 200) {
                    var all_sports = response.data.data
                    let non_custom_sports = []
                    let custom_sports = []
                    for (var i = 0; i < all_sports.length; i++) {
                        if (checkEventManageforSports(all_sports[i].id)) {
                        if (all_sports[i].is_custom == 0) {
                            if(all_sports[i].slug == 'soccer') {
                                all_sports[i].name = 'football'
                            }
                            non_custom_sports.push(all_sports[i])
                        } else {
                            custom_sports.push(all_sports[i])
                        }
                    }
                    }
                    non_custom_sports.sort((a, b) => {
                        return a.slug.localeCompare(b.slug)
                    });

                    var sport_list = {}
                    sport_list['custom'] = custom_sports
                    sport_list['non_custom'] = this.sortedNonCustomSports(non_custom_sports);
                    this.$store.dispatch('setSportsList',sport_list);
                    this.handleBeforeGettingMatchesList();
                }
            }
        }).catch(error => {
            this.loading = false;
            this.$store.dispatch('setGlobalLoader', false);
            if (error) {
                console.log(error)
                this.$errorToast(error);
            }
        });
    },
    handleBeforeGettingMatchesList(){
        this.sportsList = this.sports_list; 
        let initSport = this.sportsList?.non_custom?.[0];
        this.getSportsList(initSport);
    },
    sortedNonCustomSports(sports) {
        const order = ['cricket', 'football', 'tennis'];
        return sports.sort((a, b) => {
            const aIndex = order.indexOf(a.name.toLowerCase());
            const bIndex = order.indexOf(b.name.toLowerCase());

            if (aIndex !== -1 || bIndex !== -1) {
            return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
            }
            return a.rank - b.rank;
        });
    },
    getCasinoGamesServiceCall() {
        let casinoGames = this.gamesData;
        if (this.$auth.status) {
            checkInEventMangeForSection(casinoGames)
            this.$store.dispatch('setGamesData', casinoGames);
        }
        let sectionsList = casinoGames?.sections;
        this.sectionWiseGamesList[0].gamesList = sectionsList.find(sl => sl.slug == 'our-casino');
        this.$nextTick(() => {
            let targetElement = document.getElementById('casinosection');
            if (targetElement && !this.CasinoObserver) {
                this.CasinoObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.CasinoObserver.unobserve(entry.target);
                            this.showCasino = true;
                            this.CasinoObserver = null;
                        }
                    });
                });
                this.CasinoObserver.observe(targetElement);
            }
        });
    },
    getSportsList(sport = false) {
        this.loading = true;
        let sportID = sport.id;
        this.$apiCall('get', 'MATCHES_BY_SPORT_ID', null, 'sports', { sport_id: sportID }).then(response => {
            this.loading = false;
            this.$store.dispatch('setGlobalLoader', false);
            if (response) {
                if (response.status == 200) {
                    sport && (this.activeTab = sport.slug);
                    this.matches_list = response.data.data;
                    for (let match of this.matches_list) {
                        this.marketOdds[match.market_id] = match.runners??[];
                    }
                    this.leagueList = this.getLeagueList(this.matches_list);                        
                }
            }
        }).catch(error => {
            this.$store.dispatch('setGlobalLoader', false);
            this.loading = false;
            if (error) {
                this.$errorToast(error);
            }
        });
    },
    getLeagueList(arr) {
        return arr.filter((obj, index) => {
            return index === arr.findIndex(o => obj.league_name === o.league_name);
        });
    },
    getSportsListService(item) {
        if(this.$route.params.head_sport) {
            this.$router.push({params: {type: '', id: '', head_sport : ''}});
        };
        this.getSportsList(item);
    },
    getSportImage(sportId) {
        const imageMap = {
            4: require("@/assets/images/sports-cricket.svg"),
            1: require("@/assets/images/sports-soccer.svg"),
            2: require("@/assets/images/sports-tennis.svg"),
            1477: require("@/assets/images/sports-rugby-league.svg"),
            6: require("@/assets/images/sports-boxing.svg"),
            5: require("@/assets/images/sports-rugby-union.svg"),
            3: require("@/assets/images/sports-golf.svg"),
            27454571: require("@/assets/images/sports-esports.svg"),
            2152880: require("@/assets/images/sports-gaelic-football.svg"),
            998917: require("@/assets/images/sports-volleyball.svg"),
            7524: require("@/assets/images/sports-ice-hockey.svg"),
            7522: require("@/assets/images/sports-basketball.svg"),
            7511: require("@/assets/images/sports-baseball.svg"),
            6423: require("@/assets/images/sports-american-football.svg"),
            6422: require("@/assets/images/sports-snooker.svg"),
            11: require("@/assets/images/sports-cycling.svg"),
            8: require("@/assets/images/sports-motor-sport.svg"),
            2378961: require("@/assets/images/sports-politics.svg"),
            468328: require("@/assets/images/sports-handball.svg"),
            61420: require("@/assets/images/sports-australian-rules.svg"),
            3503: require("@/assets/images/sports-darts.svg"),
            10: require("@/assets/images/sports-special-bets.svg"),
            26420387: require("@/assets/images/sports-mixed-martial-arts.svg"),
            4339: require("@/assets/images/sports-greyhound-racing.svg"),
            7: require("@/assets/images/sports-horse-racing.svg"),
            27454574: require("@/assets/images/sports-kabaddi.svg"),
        };
        return imageMap[sportId] || require("@/assets/images/sports-no.svg");
    },
},
};
</script>

<style scoped>
/* .mobile-game-live.sports-height .game-listing-container{
max-height: none;
} */
</style>
